import React from 'react';
import Subscriptions from "./User/Subscriptions";
import {useDashboard} from "../../utilities/context/dashboard/dashboard-context";
import Profile from "./User/Profile";


const UserPanel = ({_user}) => {

    const {user} = useDashboard();

    return (
        <div className="w-full">
            {user && <Profile />}
            <Subscriptions />
        </div>
    );
};

export default UserPanel;